import { PDP_VARIANTS_POSITION } from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import store from 'shared/store'
import Storage from 'views/assets/scripts/services/storage/storage'

import { PdpVariantsPosition } from './PdpVariantsPosition'

const activate = () => {
  const container = document.querySelector<HTMLElement>('#h_ProductVariants')
  const {
    pageProperties: { experiments },
  } = store.getState().publicRuntimeConfig
  const experiment = getExperiment(PDP_VARIANTS_POSITION, experiments)

  if (!experiment.isEnabled || experiment.variant !== 'v1' || !container) {
    return
  }

  const storage = new Storage('sessionStorage')
  new PdpVariantsPosition(container, storage).init()
}

export default activate
